import LoginReducer from '../Reducers/LoginReducer';
import { combineReducers } from "redux";
import SpinnerReducer from '../Reducers/SpinnerReducer';
import CommonMastersReducer from '../Reducers/CommonMastersReducer';
import AcStudentsMarksCourseReducer from '../Reducers/AcStudentsMarksCourseReducer';
import ZoneMapReducer from '../Reducers/ZoneMappingReducer';
import SeatingArrangementReducer from '../Reducers/SeatingArrangementReducer';
import ServiceDashboardReducer from '../Reducers/ServiceDashBoardReducer';
import LoginPaymentReducer from '../Reducers/LoginPaymentReducer';
import DrillDownReducer from '../Components/Taxes/AssesmentDetails/DrillDownReducer'
import PaymentReducer from '../Reducers/PaymentReducer';
import TapFeeReducer from '../Reducers/TapFeeReducer';
import InsideTradeLicenseReducer from '../Reducers/InsideTradeLicenseReducer';
import OutsideTapFeeReducer from '../Reducers/OutsideTapFeeReducer';
import OutsideTradelicensereducer from '../Reducers/OutsideTradelicensereducer';
import CellTowerReducer from '../Reducers/CellTowerReducer';
import OutsideCellTowerReducer from '../Reducers/OutsideCellTowerReducer';
import AuctionReducer from '../Reducers/AuctionReducer';
import OutsideAuctionReducer from '../Reducers/OutsideAuctionReducer';
import SvamitvaReducer from '../Reducers/SvamitvaReducer';


 
const Reducers = combineReducers({
    loginreducer: LoginReducer,
    spinner: SpinnerReducer,
    commonmastersreducer: CommonMastersReducer,
    acstudentsmarkscoursereducer: AcStudentsMarksCourseReducer,
    zoneMapReducer: ZoneMapReducer,
    seatingarrangementreducer: SeatingArrangementReducer,
    servicedashboardreducer: ServiceDashboardReducer,
    loginpaymentreducer: LoginPaymentReducer,
    drillDownReducer: DrillDownReducer,
    paymentreducer: PaymentReducer,
    tapfeepaymentreducer:TapFeeReducer,
    outsidetapfeepaymentreducer:OutsideTapFeeReducer,
    licensereducer:InsideTradeLicenseReducer,
    outsidelicensereducer:OutsideTradelicensereducer,
    celltowerreducer:CellTowerReducer,
    outsidecellreducer:OutsideCellTowerReducer,
    auctionreducer:AuctionReducer,
    outsideauctionreducer: OutsideAuctionReducer,
     svamitvareducer: SvamitvaReducer,
})

export default Reducers;